import React, {useEffect, useState} from "react";
import heic2any from "heic2any";
import { FullScreenLoader } from "src/app/components";

const HeicViewerUI = ({ docs }: { docs: Array<{ uri: string }> }) => {

    const [imageUrl, setImageUrl] = useState<string>('')
    const [imageLoading, setImageLoading] = useState<boolean>(true);

    useEffect(() => {
        const url: string = docs?.[0]?.uri || ''
        if (url) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => heic2any({ blob, toType: 'image/jpeg' }))
                .then(converted => setImageUrl(URL.createObjectURL(converted as Blob)));
        }
    }, [docs]);


    const toggleImageLoading = () => {
    setImageLoading(!imageLoading);
    }

    return (
        <>
            {imageLoading ? <FullScreenLoader /> : null}
            {imageUrl ?
                <img 
                    className="image-view" 
                    src={ imageUrl } 
                    alt={'image-url'}
                    onLoad={toggleImageLoading}
                    onError={toggleImageLoading}
                /> :
                null
            }
        </>
    )
};

export default HeicViewerUI;